import { render, staticRenderFns } from "./BuyNowPayLater.vue?vue&type=template&id=1674abc4&scoped=true"
import script from "./BuyNowPayLater.vue?vue&type=script&lang=js"
export * from "./BuyNowPayLater.vue?vue&type=script&lang=js"
import style0 from "./BuyNowPayLater.vue?vue&type=style&index=0&id=1674abc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1674abc4",
  null
  
)

export default component.exports